import React from 'react';
import Form from '../components/Form';

/**
 * Render Page : Login
 *
 * @category Pages
 * @component
 * @returns { React.Component } A React component
 */
function Login () {
    return (
        <main className='main bg-dark'>
            {/* Returns form component */}
            < Form />
        </main>      
    )
}

export default Login;